import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import FileViewer from "../../components/File/FileViewer";

const FilePreview = ({classes, filename, fileConfig, renderer}) => (
    <div className={classes.document}>
        <FileViewer
            filename={filename}
            fileConfig={fileConfig}
            renderer={renderer}
        />
    </div>
);

const styles = theme => ({
    document: {
        backgroundColor: theme.colors.darkPaleGray,
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(FilePreview);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/file/Preview.jsx